import React from 'react';
import type { ProgramStatus } from '../types/landing';
const map: Record<ProgramStatus, {
  label: string;
  cls: string;
}> = {
  open: {
    label: 'Registration open',
    cls: 'bg-status-openBg text-status-open'
  },
  waitlist: {
    label: 'Waitlist',
    cls: 'bg-status-waitBg text-status-wait'
  },
  upcoming: {
    label: 'Coming soon',
    cls: 'bg-status-soonBg text-status-soon'
  }
};
export function ProgramStatusBadge({
  status
}: {
  status: ProgramStatus;
}) {
  const {
    label,
    cls
  } = map[status];
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-sm px-2 py-0.5 text-[11px] font-semibold ${cls}`} data-id="element-152" data-mp="1kvl3looudpf9">
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" data-id="element-153" data-mp="1owws1qvzc4lv" />
      {label}
    </span>;
}